import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-bidding',
  templateUrl: './bidding.component.html',
  styleUrl: './bidding.component.css'
})
export class BiddingComponent {
  displayedColumns: string[] = [
    'srNo',
    'projectName',
    'projectManager',
    'email',
    'bidStartDate',
    'bidEndDate',
    'status',
    'action'
  ];

  dataSource = new MatTableDataSource<any>([]);
  searchKeyword = '';
  currentStatusFilter = '';
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService
  ) {}

  ngOnInit(): void {
    this.fetchData();
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const matchStatus = !this.currentStatusFilter ||
        (data.status && data.status.toLowerCase() === this.currentStatusFilter.toLowerCase());
      const searchStr = [
        data.projectName,
        data.clientName,
        data.email,
        data.orgName,
        data.status
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      const matchSearch = !filter || searchStr.indexOf(filter.toLowerCase()) !== -1;
      return matchStatus && matchSearch;
    };
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim();
    this.dataSource.filter = filterValue;
  }

  filterByStatus(event: any): void {
    this.currentStatusFilter = (event.target as HTMLSelectElement).value || '';
    this.dataSource.filter = this.dataSource.filter || ' '; // trigger predicate
  }

  fetchData(): void {
    this.apiService.getProjectBidding().subscribe({
      next: (res: any) => {
        this.dataSource.data = res?.data ?? res ?? [];
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.errorMessage || err?.error?.error || 'Failed to load bidding list');
      }
    });
  }

  deleteBidding(element: any): void {
    if (!confirm('Are you sure you want to delete this bidding record?')) {
      return;
    }
    this.apiService.deleteProjectBidding(element.id).subscribe({
      next: () => {
        this.toastrMsgService.success('Bidding record deleted successfully');
        this.fetchData();
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.errorMessage || err?.error?.error || 'Failed to delete');
      }
    });
  }

  getStatusClass(status: string): string {
    if (!status) return 'bg-gray-100 text-gray-800';
    const s = status.toLowerCase();
    if (s === 'pending') return 'bg-yellow-100 text-yellow-800';
    if (s === 'verified' || s === 'accepted') return 'bg-green-100 text-green-800';
    if (s === 'rejected') return 'bg-red-100 text-red-800';
    return 'bg-gray-100 text-gray-800';
  }

  getStatusColor(status: string): 'primary' | 'accent' | 'warn' {
    const s = (status || '').toLowerCase();
    if (s === 'pending') return 'accent';
    if (s === 'verified' || s === 'accepted') return 'primary';
    if (s === 'rejected') return 'warn';
    return 'primary';
  }
}